import { createPageApp } from '@/lib/createPageApp'
import CategoryPage from './CategoryPage.vue'

createPageApp(CategoryPage).mount()
